export var TypeActionBuyWithGold;
(function (TypeActionBuyWithGold) {
    TypeActionBuyWithGold["BeginProcess"] = "BuyWithGold > BeginProcess";
    TypeActionBuyWithGold["CheckGoldConfirmationNeeded"] = "BuyWithGold > CheckGoldConfirmationNeeded";
})(TypeActionBuyWithGold || (TypeActionBuyWithGold = {}));
export var actionBeginBuyWithGoldProcess = function (playerGold, requiredGold, onProcessConfirmed, onProcessDenied, onNotEnoughGold, onConfirmationNeeded, onProcessPreConfirm) { return ({
    onConfirmationNeeded: onConfirmationNeeded,
    onNotEnoughGold: onNotEnoughGold,
    onProcessConfirmed: onProcessConfirmed,
    onProcessDenied: onProcessDenied,
    onProcessPreConfirm: onProcessPreConfirm,
    playerGold: playerGold,
    requiredGold: requiredGold,
    type: TypeActionBuyWithGold.BeginProcess,
}); };
export var actionCheckGoldConfirmationNeeded = function (requiredGold, onProcessConfirmed, onProcessDenied, onConfirmationNeeded, onProcessPreConfirm) { return ({
    onConfirmationNeeded: onConfirmationNeeded,
    onProcessConfirmed: onProcessConfirmed,
    onProcessDenied: onProcessDenied,
    onProcessPreConfirm: onProcessPreConfirm,
    requiredGold: requiredGold,
    type: TypeActionBuyWithGold.CheckGoldConfirmationNeeded,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/buy-with-gold/actionBuyWithGold.ts
// module id = 62
// module chunks = 3